interface PageHeroProps {
  eyebrow?: string;
  title: string;
  desc?: string;
}

export default function PageHero({ eyebrow, title, desc }: PageHeroProps) {
  return (
    <section className="page-hero">
      <div className="container">
        {eyebrow && <p className="page-eyebrow">{eyebrow}</p>}
        <h1>{title}</h1>
        {desc && <p className="page-hero-desc">{desc}</p>}
      </div>
    </section>
  );
}
